import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../../assets/logo.png';

const links = [
  { label: 'Home',               href: '/#home'            },
  { label: 'Our Way',            href: '/#team'            },
  { label: 'Our Capabilities',   href: '/#services'        },
  { label: 'Campus Charter',     href: '/campus-charter'   },
  { label: 'Chalking Out Brands',href: '/#chalking-brands' },
  { label: 'Contact',            href: '/#contact'         },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen]         = useState(false);
  const navigate  = useNavigate();
  const location  = useLocation();

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  const handleNav = (e, href) => {
    e.preventDefault();
    setOpen(false);
    if (href.startsWith('/#')) {
      const id = href.slice(2);
      if (location.pathname !== '/') {
        navigate('/');
        setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }), 120);
      } else {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(href);
      window.scrollTo(0, 0);
    }
  };

  return (
    <header className={`nav-bar${scrolled ? ' solid' : ''} w-full`}>
      <div className="max-w-content mx-auto px-6 flex items-center justify-between h-20">

        <a href="/" onClick={e => handleNav(e, '/')} className="flex items-center shrink-0">
          <img src={logo} alt="Chalk and Charter" className="h-12 w-auto object-contain" />
        </a>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-7">
          {links.map(l => (
            <a
              key={l.href}
              href={l.href}
              onClick={e => handleNav(e, l.href)}
              className="text-xs font-semibold tracking-wide text-white/60 hover:text-white transition-colors duration-200 whitespace-nowrap"
            >
              {l.label.toUpperCase()}
            </a>
          ))}
        </nav>

        <a href="/#contact" onClick={e => handleNav(e, '/#contact')}
          className="btn-red hidden lg:inline-flex text-xs px-5 py-2.5">
          Get in Touch
        </a>

        {/* Hamburger */}
        <button onClick={() => setOpen(o => !o)} className="lg:hidden flex flex-col gap-[5px] p-1" aria-label="Menu">
          <span className={`block w-5 h-0.5 bg-white transition-all duration-300 origin-center ${open ? 'rotate-45 translate-y-[7px]' : ''}`} />
          <span className={`block w-5 h-0.5 bg-white transition-all duration-300 ${open ? 'opacity-0' : ''}`} />
          <span className={`block w-5 h-0.5 bg-white transition-all duration-300 origin-center ${open ? '-rotate-45 -translate-y-[7px]' : ''}`} />
        </button>
      </div>

      {/* Mobile */}
      <div className={`lg:hidden overflow-hidden transition-all duration-300 ${open ? 'max-h-96' : 'max-h-0'}`}>
        <nav className="flex flex-col px-6 pb-5 gap-4 border-t border-white/5 pt-4">
          {links.map(l => (
            <a key={l.href} href={l.href} onClick={e => handleNav(e, l.href)}
              className="text-xs font-semibold tracking-wide text-white/70 hover:text-white transition-colors py-1">
              {l.label.toUpperCase()}
            </a>
          ))}
          <a href="/#contact" onClick={e => handleNav(e, '/#contact')}
            className="btn-red text-xs px-5 py-2.5 mt-1 text-center">
            Get in Touch
          </a>
        </nav>
      </div>
    </header>
  );
}
